// Pure helpers for the EmailSidebarSection — extracted into a
// JSX-free module so tests in tests/web/* can import without
// needing JSX enabled in the test tsconfig.
//
// v1.x phase 11.17 polish round 2.

// Detect Outlook Web Access's auto-generated search folders. OWA
// creates these silently every time the user runs a search; they
// appear as opaque `OwaFV15.1AllItems` / `OwaFV16.0Folder123`
// names that mean nothing to the advisor. Real user-created
// Stewardship search folders pass through this filter.
export function isOwaAutoGeneratedName(name: string): boolean {
  if (!name) return true;
  // Match `OwaFV\d+\.X*` so we cover whatever Microsoft bumps the
  // prefix to in future Outlook Web releases (currently OwaFV15.x).
  return /^OwaFV\d+\./i.test(name);
}
